<template>
  <v-data-table
    :headers="users_headers"
    :items="users_items"
    class="elevation-1"
    :loading="usrLoading"
    loading-text="Загружаю данные"
    item-key="EMP_UUID"
    :search="usrSearch"
    show-select
    locale="ru-RU"
    dense
    :value="value"
    @input="setValue"
    :footer-props="{
        itemsPerPageText: 'На страницу',
        itemsPerPageAllText: 'Все',
        pageText: 'из'
      }"
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Пользователи</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="usrSearch"
          append-icon="mdi-magnify"
          label="Искать"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-btn icon @click="$emit('onCloseWindow', true)" v-if="mode === 'compact'">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import { USER_GET_USERS } from '@/store/actions/user'

export default {
  name: 'userBossListTable',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    mode: {
      type: String,
      default: 'full'
    }
  },
  data () {
    return {
      users_headers: [
        { text: 'ФИО', value: 'USR_FIO' },
        { text: 'Должность', value: 'EMP_WTITLE' }
      ],
      usrLoading: false,
      usrSearch: '',
      users_items: []
    }
  },

  computed: {},
  watch: {
  },

  mounted: function () {
    if (this.users_items.length === 0) {
      this.getUsersList()
    }
  },
  methods: {
    setValue (val) {
      console.log('userBossListTable setting value to ', val)
      this.$emit('input', val)
    },
    getUsersList () {
      this.usrLoading = true
      this.$store.dispatch(USER_GET_USERS)
        .then(resp => {
          this.users_items.splice(0, this.users_items.length, ...resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения списка пользователей: ' + err })
        })
        .finally(
          this.usrLoading = false
        )
    }
  }
}

</script>
